import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PropertytypeBuildingOutline(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M9 6H14V8H9V6ZM9 12H14V10H9V12ZM18 22H5V1H18V22ZM16 3H7V20H10V18.5C10 17.6716 10.6716 17 11.5 17C12.3284 17 13 17.6716 13 18.5V20H16V3Z",
    fill: "currentColor"
  }));
}